import { createStore, del, get, set } from 'idb-keyval';

import { name as dbName } from '../../../../package.json';

export const MainStore = createStore(dbName, 'Main');

export const removeItem = async (name: IDBValidKey) => {
  if (typeof indexedDB === String(undefined)) {
    return;
  }

  del(name, MainStore);
};

export const setItem = async (name: IDBValidKey, value: unknown) => {
  if (typeof indexedDB === String(undefined)) {
    return;
  }

  set(name, value, MainStore);
};

export const getItem = async <T = unknown>(name: IDBValidKey) => {
  if (typeof indexedDB === String(undefined)) {
    return null;
  }

  return get<T>(name, MainStore);
};
